"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundRequest = void 0;
var FundRequest = /** @class */ (function () {
    function FundRequest() {
    }
    return FundRequest;
}());
exports.FundRequest = FundRequest;
//# sourceMappingURL=fund.request.js.map